//chapter1
export default {
    id : 5,//chapter number
    title : '05. FMEA 개요 (5) - Failure 이해와 관리',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c05.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'Failure 이해와 관리',
            ],
            body2 : [
                'Failure 이해와 관리에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '05.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : '고장과 불량은 동일한 내용이다.',//html available
                    answer : "2",
                    explain : '불량은 고장으로부터 연결되어 양, 불의 판단결과이다.'
                },
                {
                    type : 'ox',
                    question : '설계 FMEA에서 고장원인은 공정 FMEA에서 고장영향이다.',//html available
                    answer : "2",
                    explain : '고장형태로 정의되어야 한다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. 고장의 이해</h3>
                        <li>각 시스템, 서브 시스템, 콤포넌트 요구사항에 대한 실패</li>
                        <p class="mg10"></p>
                        <h3>2. 고장의 발생구조</h3>
                        <li>FMEA와 특성의 연결 구조</li>
                        <p class="mg10"></p>
                        <h3>3. 제품과 공정의 구성과 정보연계에 따른 고장연계</h3>
                        <li>고장발생 구조와 FMEA 적용구조</li>
                        <li>공정개발 방법과 FMEA 연계</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c05.mp4',
        },
    ]
}